Vue.component('request', {
    props: ['user'],
    data: function(){
        return {
        }
    },
    mounted: function(){

    },
    methods: {
        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag angelegt wurde
         */
        onObjectCreated:function(){
            swal.fire({
                title: this.$t("requests.request-created-title"),
                text: this.$t("requests.request-created-text"),
                icon: "success",
                timer: 5000
            }).then(() => {
                window.location.href = '/request';
                // TODO: Nach dem Senden einer Anfrage fragen was gemacht werden soll. Ggf. Weitere Anfrage?
            });
        },

        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag angelegt wurde - aus dem vollständigen Seitenkontext
         */
        onObjectCreatedPageContext:function(){
            swal.fire({
                title: this.$t("requests.requestpage-created-title"),
                text: this.$t("requests.requestpage-created-text"),
                icon: "success",
                timer: 5000
            }).then(() => {
                window.location.href = '/requests';
                // TODO: Nach dem Senden einer Anfrage fragen was gemacht werden soll. Ggf. Weitere Anfrage?
            });
        },

        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag aktualisiert wurde
         */
        onRequestUpdated:function(){
            swal.fire({
                title: this.$t("requests.updated-title"),
                text: this.$t("requests.updated-text"),
                icon: "success",
                timer: 5000
            }).then(() => {
                //window.location.href = '/home';
                this.$router.push({ name: 'dashboard'});
            });
        },

        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag genehmigt wurde
         */
        onRequestApproved:function(){
            swal.fire({
                title: this.$t("requests.approved-title"),
                text: this.$t("requests.approved-text"),
                icon: "success",
                timer: 5000
            }).then(() => {
                //window.location.href = '/home';
                this.$router.push({ name: 'dashboard'});
                // TODO: Nach dem Senden einer Anfrage fragen was gemacht werden soll. Ggf. Weitere Anfrage?
            });
        },

        /**
         * Eventhandler wird aufgerufen, wenn ein Antrag abgelehnt wurde
         */
        onRequestRejected:function(){
            swal.fire({
                title: this.$t("requests.rejected-title"),
                text: this.$t("requests.rejected-text"),
                icon: "warning",
                timer: 5000
            }).then(() => {
                window.location.href = '/#';
                // TODO: Nach dem Senden einer Anfrage fragen was gemacht werden soll. Ggf. Weitere Anfrage?
            });
        },
    },
});
